import { render, staticRenderFns } from "./PlaceHolderPage.vue?vue&type=template&id=0b498664&"
import script from "./PlaceHolderPage.vue?vue&type=script&lang=ts&"
export * from "./PlaceHolderPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b498664')) {
      api.createRecord('0b498664', component.options)
    } else {
      api.reload('0b498664', component.options)
    }
    module.hot.accept("./PlaceHolderPage.vue?vue&type=template&id=0b498664&", function () {
      api.rerender('0b498664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/PlaceHolderPage.vue"
export default component.exports